import { render, staticRenderFns } from "./BlockRecordVideo.vue?vue&type=template&id=23a57f4e"
import script from "./BlockRecordVideo.vue?vue&type=script&lang=js"
export * from "./BlockRecordVideo.vue?vue&type=script&lang=js"
import style0 from "./BlockRecordVideo.vue?vue&type=style&index=0&id=23a57f4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports